import { Cart } from '../cart.model';

export class CartResponseModel {
    public cart: Cart;
    public totalPrice: number;
    public message: string;

    constructor(init?: Partial< CartResponseModel>) {}
}
